import { Card, CardBody, CardHeader } from '@heroui/react'
import { useFormContext, useWatch } from 'react-hook-form'
import { cn } from '@/lib/utils'
import { EnableDisableSection } from './EnableDisableSection'
import { HeadersSection } from './HeadersSection'
import { SipOptions } from './SipOptions'

export function OutboundTab({ headers, addHeader, removeHeader, isDisabled }) {
  const { control } = useFormContext()
  const isEnabled = useWatch({ control, name: 'outbound.enabled' })

  return (
    <div className="flex flex-col gap-6">
      <EnableDisableSection direction="outbound" isDisabled={isDisabled} />
      <div className={cn([!isEnabled && `
        pointer-events-none cursor-not-allowed opacity-40
      `, `flex flex-col gap-6`])}
      >
        <Card shadow="sm" radius="none" className="px-4 py-2">
          <CardHeader className="pb-1">
            <h3 className="text-lg font-medium">SIP Options</h3>
          </CardHeader>
          <CardBody>
            <SipOptions control={control} isDisabled={isDisabled} />
          </CardBody>
        </Card>
        <HeadersSection
          direction="outbound"
          headers={headers}
          addHeader={addHeader}
          removeHeader={removeHeader}
          isDisabled={isDisabled}
        />
      </div>
    </div>
  )
}
